import Sb from "../abstract/StatefulBehavior";
import classNames from "classnames";
import { focusable as domFocusable } from "../../helpers/utilities";
import { showSecondaryNav, hideSecondaryNav } from "./overlayHelpers";

export default class ToggleSearchOverlay extends Sb {
  constructor(el, props, refs) {
    super();

    this.state = {
      open: false,
    };
    this.refs = refs;
    this.props = props;

    if (!refs.searchOverlayToggle || !refs.searchOverlay) return false;

    this.initToggleClass = this.toggle.className;
    this.initOverlayClass = this.overlay.className;
    this.initBodyClass = document.body.className;

    this.update();
    this.bindEvents();
  }

  get toggle() {
    return this.refs.searchOverlayToggle;
  }

  get overlay() {
    return this.refs.searchOverlay;
  }

  get overlayFocusable() {
    return domFocusable(this.overlay);
  }

  get allFocusable() {
    return [this.toggle].concat(this.overlayFocusable);
  }

  get firstInput() {
    return this.overlay.querySelector("input");
  }

  update = () => {
    const { open } = this.state;

    this.toggle.setAttribute("aria-expanded", open);
    this.toggle.className = classNames(this.initToggleClass, {
      "is-toggled": open,
      "is-untoggled": !open,
    });

    this.overlayFocusable.forEach((el) =>
      el.setAttribute("tabindex", open ? 0 : -1)
    );
  };

  bindEvents() {
    this.toggle.addEventListener("click", this.handleClick);
  }

  handleClick = (event) => {
    this.state.open ? this.closeOverlay() : this.openOverlay();
  };

  openOverlay() {
    window.addEventListener("keydown", this.handleKeyDown);
    this.overlay.className = classNames(this.initOverlayClass, "is-open");
    this.setState({ open: true });
    if (this.firstInput) this.firstInput.focus();
    if (this.props.onOpen) this.props.onOpen();
    hideSecondaryNav();
  }

  closeOverlay() {
    if (!this.state.open) return null;

    window.removeEventListener("keydown", this.handleKeyDown);
    this.overlay.className = classNames(this.initOverlayClass, "is-closed");
    this.setState({ open: false });
    if (this.props.onClose) this.props.onClose();
    showSecondaryNav(this.refs.searchOverlay);
  }

  handleKeyDown = (event) => {
    const { key, shiftKey } = event;
    if (key !== "Escape" && key !== "Tab") return;
    key === "Escape" && this.closeOverlay();
    key === "Tab" && this.handleTab(event);
  };

  handleTab(event) {
    if (!this.overlayFocusable || !this.overlayFocusable.length) return false;

    const focusedItem = document.activeElement;
    const focusableIndex = this.allFocusable.indexOf(focusedItem);

    const lastIndex = event.shiftKey
      ? focusableIndex === 0
      : focusableIndex === this.allFocusable.length - 1;

    // if tab or shift + tab will remain within this.allFocusable,
    // proceed with default key behavior
    if (!lastIndex) return;

    // if not, prevent default and jump to other end of this.allFocusable
    event.preventDefault();
    const nextFocus = event.shiftKey
      ? this.allFocusable[this.allFocusable.length - 1]
      : this.allFocusable[0];
    nextFocus.focus();
  }
}
